import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { Routes, Route } from 'react-router-dom';
import AcademicLayout from './components/layouts/AcademicLayout';
import Home from './pages/Home';
import UnifiedPage from './components/UnifiedPage';
import Certificates from './pages/Certificates';
import './styles/academic.css';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<AcademicLayout><Home /></AcademicLayout>} />

        <Route path="/notes" element={<AcademicLayout><UnifiedPage category="notes" title="NOTES_AND_LOGS" /></AcademicLayout>} />
        <Route path="/academia" element={<AcademicLayout><UnifiedPage category="academia" title="ACADEMIA" /></AcademicLayout>} />
        <Route path="/finance" element={<AcademicLayout><UnifiedPage category="finance" title="QUANTITATIVE FINANCE" /></AcademicLayout>} />
        <Route path="/ml_ai" element={<AcademicLayout><UnifiedPage category="ml_data" title="MACHINE LEARNING & DATA" /></AcademicLayout>} />
        <Route path="/software_infra" element={<AcademicLayout><UnifiedPage category="engineering" title="ENGINEERING" /></AcademicLayout>} />
        <Route path="/videos" element={<AcademicLayout><UnifiedPage category="videos" title="VIDEO LOGS" /></AcademicLayout>} />
        <Route path="/certs" element={<AcademicLayout><Certificates /></AcademicLayout>} />
        <Route path="/networking" element={<AcademicLayout><UnifiedPage category="networking" title="NETWORKING & EVENTS" /></AcademicLayout>} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
